exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._15G5g6nmSbVDf-y4QG9yC9 div[class~=ms-Dialog-main]{width:415px;overflow:hidden}html[dir] ._3KGId-vgebwzGf2qYwZIu-{padding:15px 30px 23px 30px;background-color:var(--white)}", ""]);
// Exports
exports.locals = {
	"dialog": "_15G5g6nmSbVDf-y4QG9yC9",
	"customRecurrenceContainer": "_3KGId-vgebwzGf2qYwZIu-"
};